import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let AttrOutput = class AttrOutput extends Vue {
    radios;
    checkedVal;
    value = '';
    onCheckedVal(nv) {
        this.value = nv;
    }
    changeChecked() {
        this.$emit('input', this.value);
        this.$emit('update:checkedVal', this.value);
    }
};
__decorate([
    Prop()
], AttrOutput.prototype, "radios", void 0);
__decorate([
    Prop()
], AttrOutput.prototype, "checkedVal", void 0);
__decorate([
    Watch('checkedVal', { immediate: true })
], AttrOutput.prototype, "onCheckedVal", null);
AttrOutput = __decorate([
    Component({
        name: 'AttrOutput',
        components: {},
        i18n: {
            messages: {
                zh: {},
                en: {},
            },
        },
    })
], AttrOutput);
export default AttrOutput;
